module.exports = "publish-lights-green"